import HeaderProps from "./_header-props";
import HeaderMobile from "./_header-mobile";
import HeaderSearch from "./_header-search";
import HeaderButtonColors from "./_header-button-colors";

class HeaderBackground {
    /*
     * Checks if the header should be collapsed or not, and handles the collapsing.
     * Collapsing of the header mainly makes sure the background of the header is collapsed.
     * */
    handleHeaderCollapse(manualCollapse = false) {
        // gather all elements with transition set to in
        let $elementsWithTransitionSetToIn = HeaderProps.$header.querySelectorAll(
            ".o-list-transition--in",
        );

        // if screensize is desktop, the rootnav should not be counted later on as an element with transition set to in
        // because on desktop, the root nav only has invisible items if it's submenus are not open
        const isDesktop = matchMedia(
            `(min-width: ${HeaderProps.breakPoint})`,
        ).matches;
        if (isDesktop) {
            $elementsWithTransitionSetToIn = [
                ...$elementsWithTransitionSetToIn,
            ].filter(($element) => {
                return $element.id !== "root-nav";
            });
        }

        // if there are no elements with transition set to in, then collapse the header
        const shouldCollapse =
            $elementsWithTransitionSetToIn.length < 1 || manualCollapse;
        if (shouldCollapse) {
            HeaderProps.$header.classList.add("c-header--collapsed");

            // sync the hamburger icon with the root nav
            HeaderMobile.toggleHamburger((open = false));

            // make sure the searchbar is also closed
            HeaderSearch.searchModeOff();

            // set the visual style of all desktop header toggles to active
            HeaderButtonColors.setVisualStateOfDesktopToggles(undefined, "closed");
        } else {
            HeaderProps.$header.classList.remove("c-header--collapsed");

            // sync the hamburger icon with the root nav
            HeaderMobile.toggleHamburger((open = true));

            // if on desktop, make sure the root menu is open
            const isDesktop = matchMedia(
                `(min-width: ${HeaderProps.breakPoint})`,
            ).matches;
            if (isDesktop) {
                const $rootNav = document.querySelector("#root-nav");
                $rootNav?.setTransitionIn(true);
            }
        }
    }

    /*
     * Closes the header completely
     * */
    closeHeader() {
        const isClosed = HeaderProps.$header.classList.contains(
            "c-header--collapsed",
        );
        if (isClosed) {
            return;
        }

        // get all the transition lists within the header
        const $transitionLists = HeaderProps.$header.querySelectorAll(
            "[data-list-transition]",
        );

        // close all the transition lists
        $transitionLists.forEach(($transitionList) => {
            $transitionList.triggerTransition("close");
        });

        // toggle search mode off
        HeaderSearch.searchModeOff();

        // close the header
        this.handleHeaderCollapse(true);
    }
}

export default new HeaderBackground();
